// import useAbilitiesHelper from "@helpers/AbilitiesHelper"

export const MENU_RAW_MATS = (ability) => {
  // const [isUserAllowed] = useAbilitiesHelper(ability);
  return [
    { name: 'Purchase Contract', url: '/rawmats/purchasecontract', icon: 'bi bi-cart4', hasSubMenu: false, exactMenu: true },
    {
      name: 'Maintenance', url: '/rawmats/maintenance', icon: 'bi bi-gear', hasSubMenu: true,
      submenu: [
        { name: 'ATL Rules', url: `/rawmats/maintenance/atlrules`, isAllowed: ability.can('raw_mats_maint_atl_rules', 'Maintenance') },
        { name: 'Delivery Plant/Customer', url: '/rawmats/maintenance/lists/deliveryplant', isAllowed: ability.can('raw_mats_maint_delivery_plant', 'Maintenance'), },
        { name: 'Mail Settings', url: '/rawmats/maintenance/mailsettings', isAllowed: ability.can('raw_mats_maint_mail_settings', 'Maintenance') },
        // { name: 'List', url: `/rawmats/maintenance/lists`, permissions: ['pur_maint_po_list'], },

      ]
    },
  ]
}